<!-- 营业执照 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Form :model="newFormData" label-position="right" :label-width="80">
                <div class="form-title">外间距</div>
                <FormItem label="上下间距"
                    ><Slider
                        v-if="newFormData.content.marginData"
                        class="w300"
                        show-input
                        v-model="newFormData.content.marginData.top"
                    ></Slider
                ></FormItem>
                <FormItem label="左右间距"
                    ><Slider
                        v-if="newFormData.content.marginData"
                        class="w300"
                        show-input
                        v-model="newFormData.content.marginData.left"
                    ></Slider
                ></FormItem>
                <div class="form-title">圆角设置</div>
                <FormItem label="上圆角"
                    ><Slider
                        v-if="newFormData.content.radiusData"
                        class="w300"
                        show-input
                        v-model="newFormData.content.radiusData.top"
                    ></Slider
                ></FormItem>
                <FormItem label="下圆角"
                    ><Slider
                        v-if="newFormData.content.radiusData"
                        class="w300"
                        show-input
                        v-model="newFormData.content.radiusData.bottom"
                    ></Slider
                ></FormItem>
            </Form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: var(--primary-color);
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
::v-deep .ivu-slider-bar {
    background-color: var(--primary-color);
}
::v-deep .ivu-slider-button {
    border: 2px solid var(--primary-color);
}
</style>